import React from "react";
import GrComponentFactory from "../../../gr_component_factory";
import GrPropTypes from "../../../shared/gr_prop_types";
import SocialUpdate from "../../social_update";
import CommunityAnswerDetails from "../community_answer_details";

export default GrComponentFactory.createClass({
  displayName: "ReaderAnswerNewsfeedItem",

  propTypes: {
    resource: React.PropTypes.shape(GrPropTypes.communityAnswer()),
  },

  renderHeader() {
    const book = this.props.resource.communityQuestion.book;
    return (
      <span>
        answered a question about <a className="gr-hyperlink gr-hyperlink--bold" href={book.bookUrl}>{book.title}</a>
      </span>
    );
  },

  render() {
    const body = <CommunityAnswerDetails {...this.props.resource} />;

    return (
      <SocialUpdate
        {...this.props}
        header={this.renderHeader()}
        body={body}
      />
    );
  },
});
